// src/pages/authn/AuthnCreatePage.tsx
// OAuth2Client create — routed wrapper kept for the existing /authns/new URL
// (same pattern as ChatCreatePage): renders the form-kit create dialog
// (features/authn/ClientCreateDialog) always-open; closing returns to the list.

import { useNavigate } from 'react-router-dom';
import { observer } from '@react';
import { ClientCreateDialog } from '@/features/authn/ClientCreateDialog';

export const AuthnCreatePage = observer(() => {
  const navigate = useNavigate();
  return <ClientCreateDialog open onClose={() => navigate('/authns')} />;
});

export default AuthnCreatePage;
